var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"40":1,"273":1,"304":1,"493":1,"508":1,"544":1,"624":1,"697":1,"878":1,"912":1,"1061":1,"1228":1,"1283":1,"1345":1,"1426":1,"1443":1,"1533":1,"1930":1,"1964":1,"2069":1,"2282":1,"2339":1,"2457":1,"2528":1,"2533":1,"2561":1,"2609":1,"2631":1,"2645":1,"2814":1,"2828":1,"2879":1,"3042":1,"3249":1,"3323":1,"3371":1,"3554":1,"3587":1,"3659":1,"3661":1,"3673":1,"3674":1,"3689":1,"3749":1,"3751":1,"3883":1,"3978":1,"4124":1,"4140":1,"4198":1,"4228":1,"4364":1,"4502":1,"4519":1,"4591":1,"4841":1,"4870":1,"5203":1,"5207":1,"5280":1,"5471":1,"5475":1,"5569":1,"5612":1,"5627":1,"5884":1,"5979":1,"6145":1,"6147":1,"6241":1,"6244":1,"6339":1,"6852":1,"6918":1,"6974":1,"6990":1,"7478":1,"7500":1,"7545":1,"7547":1,"7554":1,"7897":1,"7934":1,"7943":1,"8075":1,"8182":1,"8188":1,"8338":1,"8432":1,"8479":1,"8571":1,"8770":1,"8837":1,"8850":1,"9106":1,"9205":1,"9245":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr